// Inspired by: https://thoughtspile.github.io/2021/04/05/useref-usememo/

import { useCustomMemo } from './useCustomMemo'

const objectPropComparator = <Deps extends { [key: string]: unknown }>(
  current: Deps,
  prev: Deps
) => {
  // Assuming that if object reference are same, no prop chagnes
  // This is valid as state updates in react are expected to be immutable.
  if (current === prev) return true

  const currentKeys = Object.keys(current)
  const prevKeys = Object.keys(prev)

  // If number of keys is not same, either a prop is added or removed, so return false.
  if (currentKeys.length !== prevKeys.length) return false

  return currentKeys.every(currentKey => {
    // check current key exists or not in prevProps
    if (!prevKeys.includes(currentKey)) {
      // this means some prop name is changed
      return false
    }
    // Doing a shallow check only
    return current[currentKey] === prev[currentKey]
  })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useObjectMemo = <Deps extends { [key: string]: any }>(
  objectToMemoize: Deps
): Deps => {
  return useCustomMemo(
    () => objectToMemoize,
    objectToMemoize,
    objectPropComparator
  )
}
